export const setBadge = (filter: any) => ({
    type: 'SET_BADGES',
    payload: filter,
  });
  